import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import { Setting } from '../../../../common/types/settings';

const moveInForm = (advisors: Setting[]): Form<Client> => {
  const advisorOptions = advisors.map((advisor) => advisor.value);

  return {
    key: 'moveIn',
    title: 'Einzug ins Frauenhaus',
    fields: [
      {
        key: 'moveInDate',
        label: 'Datum',
        fieldTypes: 'date',
      },
      {
        key: 'advisor',
        label: 'zuständig',
        fieldTypes: 'autocomplete',
        options: advisorOptions,
      },
      {
        key: 'roomNumber',
        label: 'Zimmmernummer',
        fieldTypes: 'text',
      },
    ],
  };
};

export default moveInForm;
